/**
 * The Learn tab's pages: its nav (the sidebar's Learn tab, the phone's More sheet, the palette) and its routes.
 * Builders only: people a screen was shared with never see Learn.
 */
import { lazy } from 'react'
import type { NavItem } from '../ui'

export const learnNav: NavItem[] = [
  { to: '/learn', label: 'Missions', icon: 'mission' },
  { to: '/learn/crash-course', label: 'Crash course', icon: 'learn' },
  { to: '/learn/skills', label: 'Skills', icon: 'book' },
]

export const learnRoutes = [
  { path: '/learn', title: 'Learn', component: lazy(() => import('./Home')) },
  { path: '/learn/crash-course', title: 'Crash course', component: lazy(() => import('./CrashCourse')) },
  { path: '/learn/skills', title: 'Skills', component: lazy(() => import('./Skills')) },
  { path: '/learn/missions/:id', title: 'Mission', component: lazy(() => import('./MissionPage')) },
]
